<template>
    <div class="selected-devices">
        <div class="head">
            <div class="head__title">
                <p class="text">Выбранные элементы</p>
            </div>

            <div class="head__device-quantity mb-2">
                {{ `${filteredDevices.length} элементов` }}
            </div>

            <div class="search-control mb-2">
                <input class="search-control__input form-control"
                    type="text"
                    placeholder="Поиск по номеру или адресу"
                    v-model.trim="search"
                >
                <button @click="clearSearch" v-if="search" class="search-control__input-btn reset-btn">
                    ✕
                </button>
            </div>
        </div>

        <div class="body">
            <div v-for="device in filteredDevices" :key="device.id" class="body__element">
                <div class="name">
                    {{ `${device.location?.number ?? device.number}, ${device.location?.street ?? device.street}. Тип у-ва: ${device.type?.name ?? device.type} ${device.item ?? ''}` }}
                </div>
            </div>

            <div v-if="!filteredDevices.length" class="text-muted mt-2">
                Ничего не найдено
            </div>
        </div>

        <div class="controls mt-3">
            <button class="btn btn-lg btn-primary" @click="clearDevices">
                Очистить элементы
            </button>
        </div>
    </div>
</template>

<script>
import { mapMutations } from "vuex/dist/vuex.cjs.js";
export default {
    name: 'SelectedDevices',

    props: {
        devicesFounded: { type: Array, default: () => [] },
        deviceIds: { type: Array, default: () => [] },
        addedDevicesIds: { type: Array, default: () => [] },
        regionIds: { type: Array, default: () => [] },
        locationNumbers: { type: String, default: '' },
        groupIds: { type: Array, default: () => [] },
        devicesTypeId: { type: Number, default: () => null },
    },

    data() {
        return {
            search: '',
            searchTerm: '',
            debounceTimer: null
        };
    },

    computed: {
        devicesTotal() {
            const all = [
                ...this.deviceIds,
                ...this.addedDevicesIds,
                ...this.syncDevicesByRegion(),
                ...this.syncDevicesByLocationNumber(),
                ...this.syncDevicesByGroup()
            ];

            const map = new Map(all.map(device => [device.id, device]));
            return Array.from(map.values());
        },

        filteredDevices() {
            if (!this.searchTerm) return this.devicesTotal;

            const term = this.searchTerm.toLowerCase();

            return this.devicesTotal.filter(device => {
                const values = [
                    device.location?.number,
                    device.location?.street,
                    device.type?.name,
                    device.type,
                    device.number
                ]
                    .filter(Boolean)
                    .map(v => String(v).toLowerCase());

                return values.some(v => v.includes(term));
            });
        }
    },

    emits: [
        'stateChange',
        'update:deviceIds',
        'update:regionIds',
        'update:locationNumbers',
        'update:addedDevicesIds',
        'update:groupIds',
    ],

    watch: {
        search(newVal) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.searchTerm = newVal;
            }, 300);
        },

        deviceIds: 'onDevicesChange',
        addedDevicesIds: 'onDevicesChange',
        regionIds: 'onDevicesChange',
        groupIds: 'onDevicesChange',
        locationNumbers: 'onDevicesChange',
        devicesFounded: 'onDevicesChange',
    },

    mounted() {
        this.onDevicesChange();
    },

    methods: {
        ...mapMutations('selectedDevices', ['getSelectedDevicesCount']),

        onDevicesChange() {
            const val = this.devicesTotal;

            this.getSelectedDevicesCount(val);

            if (
                !val.length &&
                !this.locationNumbers.length &&
                !this.regionIds.length
            ) {
                this.clearDevices();
            }
        },

        clearSearch() {
            this.search = '';
            this.searchTerm = '';
        },

        syncDevicesByRegion() {
            if (!this.regionIds.length || !this.devicesFounded.length) return [];

            return this.devicesFounded.filter(device =>
                this.regionIds.includes(device.location.region_id) &&
                (!this.devicesTypeId || device.type?.id === this.devicesTypeId)
            );
        },

        syncDevicesByLocationNumber() {
            const numbers = this.locationNumbers.split(' ').filter(Boolean);
            if (!numbers.length || !this.devicesFounded.length) return [];

            return this.devicesFounded.filter(device =>
                numbers.includes(device.location.number)
            );
        },

        syncDevicesByGroup() {
            if (!this.groupIds.length || !this.devicesFounded.length) return [];

            return this.devicesFounded.filter(device =>
                Array.isArray(device.groups) &&
                device.groups.some(group => this.groupIds.includes(group.id)) &&
                (!this.devicesTypeId || device.type?.id === this.devicesTypeId)
            );
        },

        clearDevices() {
            this.$emit('update:deviceIds', []);
            this.$emit('update:addedDevicesIds', []);
            this.$emit('update:regionIds', []);
            this.$emit('update:groupIds', []);
            this.$emit('update:locationNumbers', '');
            this.$emit('stateChange', false);
        }
    }
};
</script>
